import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { useCreateReferenceRate } from 'src/features/referenceRates/api/useCreateReferenceRate';
import { LIST_REFERENCE_RATES_RESOURCE } from 'src/features/referenceRates/api/useListReferenceRates';
import { referenceRatesMessages } from 'src/features/referenceRates/utils/messages';
import ReferenceRateFormModal from 'src/features/referenceRates/components/forms/ReferenceRateFormModal';

interface CreateReferenceRateFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateReferenceRateFormModal<TData>({ className }: CreateReferenceRateFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateReferenceRate({
        onSuccess: (referenceRate) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_REFERENCE_RATES_RESOURCE] });
            toast({
                title: formatMessage(referenceRatesMessages.createReferenceRateSuccess),
                description: formatMessage(referenceRatesMessages.createReferenceRateSuccessDescription, {
                    entry: referenceRate.name,
                }),
            });
        },
    });

    return (
        <ReferenceRateFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, {
                entry: formatMessage(referenceRatesMessages.referenceRate).toLowerCase(),
            })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(referenceRatesMessages.addReferenceRateSubtitle)}
        />
    );
}

export default CreateReferenceRateFormModal;
